import React, { useState } from "react";
import { Text, SwitchField, Flex, TextField, Button, useAuthenticator, Loader } from "@aws-amplify/ui-react";
import { modifyEmailAPI } from "../../data/api";

const ProfileEmail = (props) => {
  const { user } = useAuthenticator((context) => [context.user]);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(false);
    try{
      setLoading(true);
      await modifyEmailAPI(user?.username, email);
      setEmail('');
      setLoading(false);
      props.onUpdate();
    } catch (e) {
      console.log('Modify email failed ', e);
      setLoading(false);
      setError(true);
    }
  };
  
  return (
    <>
    <div className="profile-card-content">
      <Text fontWeight="600" fontSize="18px">
        Cambia email
      </Text>
      <Flex as="form" direction="column" width="400px" onSubmit={handleSubmit}>
        <TextField
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          name="name"
          label={<></>}
          type="email"
          placeholder="Inserisci una nuova email"
          marginBottom="0px"
          isRequired={true}
          disabled={loading}
        />
        <Button
          type="submit"
          width={{ base: "100%" }}
          disabled={loading || email == ''}
          variation="primary"
        >
          {loading ? <Loader/> : "Conferma cambio email"}
        </Button>
        {error ? <Text color="red">Errore nell'aggiornamento della email!</Text> : <></>}
      </Flex>
    </div>
    </>
  );
};

export default ProfileEmail;
